import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useBrandingContext } from '@/shared/context/useBrandingContext';
import styles from './AuthLayout.module.css';

export function AuthLayout() {
  const { branding } = useBrandingContext();

  return (
    <div className={styles.layout}>
      <div className={styles.panel}>
        <div className={styles.logo}>
          <span className={styles.logoIcon}>
            <Sparkles size={22} strokeWidth={1.75} aria-hidden />
          </span>
          <span className={styles.logoText}>{branding.platformName}</span>
        </div>
        <div className={styles.content}>
          <Outlet />
        </div>
        <p className={styles.footer}>
          &copy; {new Date().getFullYear()} {branding.platformName}. All rights reserved.
        </p>
      </div>
      <div className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>Grow your practice with AI</h1>
          <p>
            Automate your SEO, manage ad campaigns, and get AI-powered insights—all in one place.
          </p>
        </div>
      </div>
    </div>
  );
}
